import styles from './Message.module.css';
import { iconsSources } from '../../helpers/icons';
import { Photo } from '../Photo/Photo';
import { AnimatePresence, motion } from 'framer-motion';
import { hideNumber } from '../../helpers/titreHelper';

const Message = ({ message, rotateSign, speedSlow }) => {
  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel];
  };

  return (
    <div className={styles.wrapper}>
      <AnimatePresence mode="wait">
        <motion.div
          key={message.id}
          exit={{
            opacity: 0,
            transition: {
              delay: 0,
              duration: 0.5,
            },
          }}
          className={styles.avatarBlock}
        >
          <div className={styles.avatar}>
            <img
              src={
                (message?.image !== '1' && message?.image) ||
                iconsSources[message?.channel]
              }
              alt={message?.author}
              onError={errorHandler}
            />
            <div className={`${styles.bodrerQr} ${styles.yellow}`} />
          </div>

          {message?.author && (
            <motion.div
              initial={{ clipPath: 'inset(0 0 0 100%)', x: '-100%' }}
              animate={{ clipPath: 'inset(0 0 0 0%)', x: '-7rem' }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className={styles.authorBlock}
            >
              <motion.div className={styles.author}>
                {message.author || hideNumber(message?.senderNumber)}
              </motion.div>
            </motion.div>
          )}
        </motion.div>
      </AnimatePresence>

      <AnimatePresence mode="wait">
        <motion.div
          key={message.id}
          initial={{ y: '100vh' }}
          animate={{ y: '0' }}
          transition={{ duration: speedSlow / 1000 }}
          exit={{ y: '-100vh' }}
          className={styles.photoBlock}
        >
          <Photo
            message={message}
            rotateSign={rotateSign}
            speedSlow={speedSlow}
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default Message;
